import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@frontierag/frontier-ui-library';
import {
  Description as DescriptionIcon,
  Star as StarIcon,
} from '@frontierag/frontier-ui-library/icons';
import { GROUPED_PRODUCTS_TYPES, MAX_NUMBER_OF_PRODUCTS_PER_SUBGROUP } from 'appConstants';

import { styles } from './styles';

export default function GroupedProductSelect({
  transNamespace,
  group,
  children,
}: {
  transNamespace: string;
  group: string;
  children: ReactNode;
}) {
  const { t } = useTranslation(transNamespace);

  if (
    process.env.REACT_APP_FEATURE_FLAGS_PRODUCT_SELECTION_DISPLAY_LAST_USED !== 'true' &&
    group === GROUPED_PRODUCTS_TYPES.LAST_USED
  )
    return null;

  return (
    <>
      <Box sx={styles.group} data-testid="grouped-product-select">
        <Box color="naval.L40" height={24}>
          {group === GROUPED_PRODUCTS_TYPES.LAST_USED ? <StarIcon /> : <DescriptionIcon />}
        </Box>
        {t(`groups.${group}`, {
          maxNumberOfProductsPerSubgroup: MAX_NUMBER_OF_PRODUCTS_PER_SUBGROUP,
        })}
      </Box>
      <Box sx={styles.row}>{children}</Box>
    </>
  );
}
